import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function MakeReadyEmail({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="yellow-info-text">
                  Copy and Paste this message to owner in appfolio{" "}
                  <strong className="red-info-heading">
                    (be sure to put property address in subject line)
                  </strong>{" "}
                  This should be sent prior to the keys being turned in so we
                  have time to evaluate who will handle the work order.
                </h3>
              </Col>
              <Col span={24}>
                {" "}
                <p className="yellow-info-text">
                  Your tenant will be vacating the property above in the coming
                  weeks.
                </p>
              </Col>
              <Col span={24}>
                {" "}
                <p className="yellow-info-text">
                  We have a great crew we use for "make ready" work or if you
                  prefer to do the work yourself that is fine as well. (Be aware
                  if you plan to perform the work yourself or have a vendor of
                  your choosing do the work we will need to complete an
                  inspection prior to listing. There is a fee of $150 for an
                  inspection if you elect to do the work yourself.) If you are
                  going to use our preferred vendor we can get them in to get a
                  bid as soon as the house is vacated.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  If you plan to do yourself we will notify you when we have the
                  keys in a lockbox at the property.
                </p>
              </Col>
              <Col span={24}>
                {" "}
                <p className="yellow-info-text">
                  Be aware that if you do request a bid but elect to not use our
                  preferred vendor there may be a service call fee for their
                  estimate and inspection services.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  If you are in need of funds for the make ready work we are
                  also able to extend you credit for a fee of 10% of the total
                  amount owed. We will add this charge for any balance carried
                  after the work is completed. Please reach out if you need
                  assistance with this part of the project.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  Just let me know asap how you plan to proceed so we can get
                  things set up on our end to avoid delays.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default MakeReadyEmail;
